import {
    Component,
    Input,
    Output,
    EventEmitter,
    forwardRef,
    ViewChild,
    ElementRef,
    HostBinding
} from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
} from '@angular/forms';

@Component({
    selector: 'app-input-number',
    templateUrl: './input-number.component.pug',
    styleUrls: ['./input-number.component.less'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputNumberComponent),
        multi: true
    }]
})
export class InputNumberComponent implements ControlValueAccessor {
    @HostBinding('class.--editable') _editable: boolean = true;
    @Input() set editable(editable: boolean) {
        this._editable = editable;
    }

    @Input() value: number;
    @Input() postfix: string = '';
    @Input() min: number = 0;
    @Input() max: number = Infinity;
    @Input() step: number = 1;

    @Output() change: EventEmitter<number> = new EventEmitter();

    constructor(
    ) {
    }

    increase() {
        this._change(this.value + this.step);
    }

    decrease() {
        this._change(this.value - this.step);
    }

    onChange(value: string) {
        this._change(parseInt(value, 10));
    }

    _change(value: number) {
        this.value = value;

        this.change.emit(this.value);
        this.propagateChange(this.value);
    }

    // START: ControlValueAccessor Interface
    writeValue(value: number) {
        this.value = value;
    }

    propagateChange = (_: any) => {
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
    }
    // END: ControlValueAccessor Interface
}
